import { render, staticRenderFns } from "./NursingNotes.vue?vue&type=template&id=42b1cb19&scoped=true&"
import script from "./NursingNotes.vue?vue&type=script&lang=js&"
export * from "./NursingNotes.vue?vue&type=script&lang=js&"
import style0 from "./NursingNotes.vue?vue&type=style&index=0&id=42b1cb19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b1cb19",
  null
  
)

export default component.exports